<template>
  <div>
    <template v-if="loading">
      <spinner
        preset="large"
      />
    </template>
    <template
      v-else-if="error"
    >
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load your feed. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="loadPostDetail"
      >
        Try Again
      </button>
    </template>
    <template v-else-if="feedItems">
      <template v-if="feedItems.length">
        <post
          v-if="feedItems[0].type === 'post'"
          :post="feedItems[0]"
          :detail="true"
        />
        <looking
          v-if="feedItems[0].type === 'looking'"
          :looking="feedItems[0]"
          :detail="true"
        />
        <listing
          v-if="feedItems[0].type === 'listing'"
          :listing="feedItems[0]"
          :detail="true"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Post from '@/components/Post.vue';
import Looking from '@/components/Looking.vue';
import Listing from '@/components/Listing.vue';

export default {
  name: 'Detail',
  components: {
    Post,
    Looking,
    Listing,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      error: false,
    };
  },
  computed: {
    ...mapState([
      'feedItems',
    ]),
  },
  watch: {
    $route: 'loadPostDetail',
  },
  created() {
    this.loadPostDetail();
    this.incrementViewCount();
  },
  methods: {
    async loadPostDetail() {
      this.$store.dispatch('clear_feed_items');
      this.loading = true;

      const responseData = await this.api({
        url: `posts/${this.id}`,
        method: 'GET',
      });

      this.loading = false;

      if (responseData.status === 200) {
        this.$store.dispatch('set_feed_items', [responseData.body]);
      } else {
        this.error = true;
      }
    },
    async incrementViewCount() {
      try {
        await this.api({
          url: `posts/${this.id}/view/`,
          method: 'POST',
        });
      } catch (e) {} // eslint-disable-line no-empty
    },
  },
};
</script>
